import * as flexsearch from "flexsearch";

import { search as searchApi } from "apis-v2/callables";
import { ISlide, IWorkspaceResourceSlide, IWorkspaceResourceSlideTemplate, IWorkspaceResourceWithDocument, WorkspaceResourceType } from "common/interfaces";
import { ISharedSlidesSearchDocument } from "common/interfaces/search/ISearchDocument";
import AppController from "js/core/AppController";

import { BaseWorkspaceResourcesController } from "./BaseWorkspaceResourcesController";

type ISharedSlidesPaneSlide = Pick<ISlide, "id" | "modifiedAt">;

class SharedSlidesPaneController extends BaseWorkspaceResourcesController<ISharedSlidesPaneSlide, IWorkspaceResourceSlide | IWorkspaceResourceSlideTemplate, ISharedSlidesSearchDocument> {
    protected get _documentFields(): (keyof ISharedSlidesPaneSlide)[] {
        return ["id", "modifiedAt"];
    }

    protected _searchDocumentToResourceWithDocument(searchDocument: ISharedSlidesSearchDocument): IWorkspaceResourceWithDocument<ISharedSlidesPaneSlide, IWorkspaceResourceSlide | IWorkspaceResourceSlideTemplate> {
        return {
            resource: searchDocument.resource,
            permission: searchDocument.permission,
            document: searchDocument.slide,
        };
    }

    protected async _fetchSearchIndex({ locale, workspaceId }: { locale: string, workspaceId: string }): Promise<{ indexConfig: flexsearch.DocumentOptions<any>, indexFileReadUrl: string }> {
        return searchApi.getSharedSlidesSearchIndex({ workspaceId, locale });
    }

    /**
     * Returns the data in the legacy format so it can be directly used in the old UI.
     * Must be removed after the UI is refactored.
     */
    public get legacyData() {
        return this._state.data.map(record => {
            const resource = record.resource;
            const slide = record.document;

            const usedPresentationIds = Object.keys(resource.metadata.usedInPresentations ?? {});
            const usedByUserIds = resource.metadata.usedByUsers ?? [];

            return {
                id: slide.id,
                libraryItemId: slide.id,
                workspaceId: AppController.workspaceId,
                resource,
                isTemplate: resource.resourceType === WorkspaceResourceType.SLIDE_TEMPLATE,
                isUsedInPresentations: usedPresentationIds.length > 0,
                isDisabled: !!resource.metadata.isDisabled,
                name: resource.metadata.name,
                description: resource.metadata.description,
                tags: resource.tags,
                usedByCount: usedByUserIds.length,
                presentationCount: usedPresentationIds.length,
                ratedByUsers: resource.metadata.ratedByUsers?.reduce((acc, uid) => ({ ...acc, [uid]: true }), {}) ?? {},
                ratedByCount: resource.metadata.ratedByUsers?.length ?? 0,
                createdAt: resource.createdAt,
                modifiedAt: resource.modifiedAt,
                contentModifiedAt: resource.metadata.contentModifiedAt,
                createdBy: resource.metadata.createdBy
            };
        });
    }
}

const sharedSlidesPaneController = new SharedSlidesPaneController();
export default sharedSlidesPaneController;
